import React from 'react'

const Deposit = () => {
    return (
        <div className='text-sm lg:pl-5'>A deposit of 25% of the entire charter will be required</div>
    )
}

export default Deposit